/* ica-collection-event-firer.js
   Fires industry_viewed or brand_viewed on collection-page load.
   Reads payload from #ica-collection-event-payload JSON script tag.
   Waits for window.icaEvents to be ready (set by ica-events.js).
*/
(function () {
  'use strict';
  function fire() {
    var node = document.getElementById('ica-collection-event-payload');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent || node.innerText || '{}'); } catch (e) { return; }
    if (!data || !data.mode) return;
    if (!window.icaEvents || typeof window.icaEvents.fire !== 'function') {
      // Retry up to ~3s for the events script to land.
      if (fire._retries === undefined) fire._retries = 0;
      if (fire._retries++ < 30) { setTimeout(fire, 100); }
      return;
    }
    var pc = (typeof data.products_count === 'number') ? data.products_count : 0;
    if (data.mode === 'industry') {
      window.icaEvents.fire('industry_viewed', {
        industry: data.title,
        industry_handle: data.handle,
        collection_gid: data.collection_gid,
        products_count: pc,
        source_page: 'collection'
      });
    } else if (data.mode === 'brand') {
      window.icaEvents.fire('brand_viewed', {
        brand: data.title,
        brand_handle: data.handle,
        collection_gid: data.collection_gid,
        products_count: pc,
        source_page: 'collection'
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fire);
  } else {
    fire();
  }
})();
